import React from 'react';
// eslint-disable-next-line
import { useDrag } from 'react-dnd';
import Spinner from 'Components/Spinner';
import {
  Checkbox,
  TableCell,
  TableHeaderCell,
  SquareCheckbox,
} from './CustomDesigns';
import AlterImage from '../../../../Assets/alter-image.png';
import styles from '../index.module.css';

const DraggableVideoCard = ({
  video,
  index,
  isSelected,
  onSelect,
  onCardClick,
  onViewPhotos,
  tabTitle,
  isItemSelected,
  toggleItemSelection,
  setEditItems,
  setEditItemsStatus,
  renderContent,
  changeDateFormat,
  selectedItems, // Add selectedItems prop to access all selected items
  isDragActive, // New prop to track if any drag is active
  setIsDragActive, // Function to set drag active state
}) => {
  const {
    content_id,
    video_id,
    draft_content_id,
    title,
    description,
    video_description,
    thumbnail,
    thumbnails,
    category_name,
    category,
    content_status,
    status,
    publish_date,
    created,
    video_size,
    draft_id,
    transcoder_status,
    workflow_status,
  } = video;

  const videoId = tabTitle === 2 ? draft_content_id : content_id || video_id;
  const videoTitle = title || 'Untitled';
  const videoDescription = description || video_description || '';
  const videoThumbnail = Array.isArray(thumbnail)
    ? thumbnail[0] || AlterImage
    : thumbnail || thumbnails || AlterImage;
  const videoCategory = tabTitle === 2 ? category_name || category : category;
  const videoStatus = renderContent(
    draft_id,
    content_status,
    status,
    video_id,
    transcoder_status,
    workflow_status
  );
  const videoDate = changeDateFormat(publish_date?.split(' ')[0]) || created?.split(' ')[0];
  const videoSizeFormatted = video_size < 1 && video_size > 0
      ? `${(video_size * 1024).toFixed(2)} KB`
      : video_size < 1000 && video_size > 1
      ? `${video_size} MB`
      : video_size > 1000
      ? `${(video_size / 1024).toFixed(2)} GB`
      : '--';

  const currentId = draft_id && draft_id?.slice(0, 9) !== 'old_video'
    ? draft_id
    : draft_id || content_id || draft_content_id;

const [{ isDragging }, drag] = useDrag({
  type: 'VIDEO_CARD',
  item: () => {
    // Always allow dragging this item
    const allSelectedItems = selectedItems || [];
    const currentItemSelected = isItemSelected(currentId);

    let itemData;
    if (currentItemSelected && allSelectedItems.length > 1) {
      // Multiple selected items
      itemData = {
        id: videoId,
        video,
        title: videoTitle,
        isSelected: currentItemSelected,
        selectedItems: allSelectedItems,
        count: allSelectedItems.length
      };
    } else {
      // Single item drag (even if not selected)
      itemData = {
        id: videoId,
        video,
        title: videoTitle,
        isSelected: currentItemSelected,
        selectedItems: [video], // drag just itself
        count: 1
      };
    }

    // Mark drag as active
    setIsDragActive && setIsDragActive(true);

    console.log('Drag started with item:', itemData);
    return itemData;
  },
  canDrag: () => true, // <-- allow all items to be draggable
  end: (item, monitor) => {
    setIsDragActive && setIsDragActive(false);
    const dropResult = monitor.getDropResult();
    if (item && dropResult) {
      console.log('Item dropped on target', dropResult);
    }
  },
  collect: (monitor) => ({
    isDragging: !!monitor.isDragging(),
  }),
}, [videoId, video, videoTitle, currentId, isItemSelected, setIsDragActive]);

  // Hide selected items when any drag is active
const shouldHide = isDragging || (isDragActive && isItemSelected(currentId));

  return (
    <div
      ref={drag}
      className={`${styles.videoCard} ${isSelected ? styles.selected : ''} ${isDragging ? styles.dragging : ''}`}
      style={{
        opacity: shouldHide ? 0 : 1,
        visibility: shouldHide ? 'hidden' : 'visible',
        cursor: isDragging ? 'grabbing' : 'grab',
        transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out'
      }}
    >
      <div className={styles.cardHeader}>
        {draft_content_id || content_id || video_id ? (
          <SquareCheckbox
            selected={isItemSelected(currentId)}
            onClick={() => {
              if (draft_id && draft_id?.slice(0, 9) !== 'old_video') {
                toggleItemSelection(draft_id, 'draft_id', status, video);
              } else {
                toggleItemSelection(
                  draft_id || draft_content_id,
                  'draft_id',
                  status,
                  video
                );
              }
              setEditItems((prevSelected) => {
                const idToUse = tabTitle === 0
                    ? content_id
                    : tabTitle === 2 && draft_content_id;
                if (prevSelected.includes(idToUse)) {
                  return prevSelected.filter((id) => id !== idToUse);
                }
                return [...prevSelected, idToUse];
              });
              setEditItemsStatus((prevSelectedStatus) => {
                const idToUse = status;
                if (prevSelectedStatus.includes(idToUse)) {
                  return prevSelectedStatus.filter((id) => id !== idToUse);
                }
                return [...prevSelectedStatus, idToUse];
              });
            }}
          />
        ) : (
          <Spinner />
        )}
      </div>
      <div
className={styles.cardContent}
onClick={() => onCardClick(video)}
onKeyPress={undefined}
      role="button"
      tabIndex={0}
      >
        <div className={styles.thumbnailContainer}>
          <img
            src={videoThumbnail}
            alt={videoTitle}
            className={styles.thumbnail}
            onError={(e) => {
              e.target.src = AlterImage;
            }}
          />
        </div>
        <div className={styles.cardInfo}>
          <h3 className={styles.cardTitle}>{videoTitle}</h3>
          <p className={styles.cardDescription}>{videoDescription}</p>
          <div className={styles.cardMeta}>
            <span className={styles.category}>{videoCategory}</span>
            <span className={styles.status}>{videoStatus}</span>
            <span className={styles.date}>{videoDate}</span>
            <span className={styles.size}>{videoSizeFormatted}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraggableVideoCard;
